export const mutedUntilTextForSingleSessionMutes = 'the next game';
